<template>
	<v-switch
		class="app-switch"
		:class="{ 'primary-color': primaryColor }"
		v-bind="$attrs"
		v-on="$listeners"
		inset
		dense
		hide-details
	></v-switch>
</template>

<script>
export default {
	name: 'AppControlledSwitch',
	props: {
		primaryColor: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.app-switch {
	margin: 0;
	width: 46px;
	padding: 2px 0 0px 4px;

	::v-deep {
		.v-input--switch__track {
			color: var(--forth-color) !important;
		}
		.v-input--selection-controls__ripple {
			opacity: 0;
		}
		.v-input--switch__thumb {
			color: white !important;
		}

		.primary--text {
			opacity: 1 !important;
			&.v-input--switch__track {
				color: var(--forth-color) !important;
			}
			&.v-input--selection-controls__ripple {
				opacity: 0;
			}
			&.v-input--switch__thumb {
				color: white !important;
			}
		}

		.v-input--selection-controls__input {
			margin: 0 !important;
		}
	}

	&.primary-color {
		::v-deep {
			.v-input--switch__track {
				color: var(--primary-color) !important;
			}
			.primary--text {
				&.v-input--switch__track {
					color: var(--primary-color) !important;
				}
			}
		}
	}
}
</style>
